import { createStore } from 'vuex';
import loader from './plugins/loader';

const debug = process.env.NODE_ENV !== 'production';

export const store = createStore({
    actions: {},
    mutations: {
        setStore(state, result) {
            state.results = { ...state.results, [result.name]: result.value };
        },
        setStoreModule(state, { name, value }) {
            try {
                if (state[name]) {
                    state[name].data = { ...state[name].data, ...value }
                }
            } catch (err) {
                console.error(err);
            }
        }
    },
    state: { results: {}},
    getters: {},
    modules: {
        breadcrumb: require('./modules/breadcrumb').default,
        global: require('./modules/global/global').default,
        basket: require('./modules/basket').default,
        product: require('./modules/product').default,
        banner: require('./modules/banner').default,
    },
    plugins: [ loader ],
    strict: debug,
});